var React = require('react');

function Aligncenter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.93 4.14h22.21M6.43 7.57h17.14M3.86 11h22.21M6.43 14.43h17.14M3.86 17.86h22.21"}));
}

Aligncenter.defaultProps = {"id":"Layer_1","viewBox":"0 0 30 22"};

module.exports = Aligncenter;

Aligncenter.default = Aligncenter;
